module.exports = __webpack_public_path__ + "static/img/vampire_bruxa.5b450ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/vampire_bruxa.png
// module id = VkVl
// module chunks = 0